import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface WidgetContainerProps {
  className?: string;
  children: React.ReactNode;
  containerRef?: React.Ref<HTMLDivElement>;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const ContainerComponent: React.FC<WidgetContainerProps> = ({
  className,
  children,
  containerRef,
  position = 'bottom-right',
}) => {
  return (
    <div ref={containerRef} className={className} data-position={position}>
      {children}
    </div>
  );
};

export const Container: React.FC<WidgetContainerProps> = (
  props: WidgetContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'WidgetContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
